module.exports = __webpack_public_path__ + "img/control.afa798f5.png";